import React from 'react';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import RoadmapDeliverableInvestingDetailsLayout from './RoadmapDeliverableInvestingDetailsLayout';
import RoadmapDeliverableInvestingDetailsMetaOverride from './RoadmapDeliverableInvestingDetailsMetaOverride';

const RoadmapDeliverableInvestingDetails = ({ relationship }) => {
  const { collection, loading, loadingError } = useLink(relationship.link('related'));

  return (
    <DataContainer
      component={MetaCollectionRenderer}
      componentProps={{
        collection,
        layout: RoadmapDeliverableInvestingDetailsLayout,
        metaOverrideSet: RoadmapDeliverableInvestingDetailsMetaOverride,
      }}
      loading={loading}
      loadingError={loadingError}
    />
  );
};

export default RoadmapDeliverableInvestingDetails;
